import { Box } from '@chakra-ui/react'
import { Breakpoint } from 'presentation/components/Breakpoint'
import { EverythingYouNeedGrid } from 'presentation/screens/AuthScreens/components/EverythingYouNeedGrid/EverythingYouNeedGrid'
import { SendResetPasswordEmailCard } from 'presentation/screens/AuthScreens/components/SendResetPasswordEmailCard'

export const SendResetPasswordEmailScreen = () => (
  <Box h='var(--app-height)'>
    <Breakpoint
      mobSm={<SendResetPasswordEmailCard overflow='auto' h='100%' />}
      mob={(
        <EverythingYouNeedGrid>
          <SendResetPasswordEmailCard />
        </EverythingYouNeedGrid>
      )}
    />
  </Box>
)
